import styled from "styled-components";

export const TippingHistoryBox  = styled.div`
  display: flex;
  flex-direction: column;
  ${({theme}) => theme.font.presets.regular};
  font-weight: 400;
  background-color: ${props => props.theme.components.gamingHistory.colors.background};
  color: ${props => props.theme.components.gamingHistory.colors.textColor};
  font-size: ${props => props.theme.font.size.medium};
  padding: 4rem;
  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    font-size: ${props => props.theme.font.size.small};
    padding: 1rem;
  }
`